export default __webpack_public_path__ + "static/media/onsite-instructions.78e1c55f.svg";